import React, { useMemo } from 'react';
import { Box } from '@mui/material';

const BADGE_SIZE = 44;

interface SonosModelBadgeProps {
  modelo?: string | null;
  size?: number;
}

function displayModel(raw?: string | null): string {
  const trimmed = (raw || '').trim();
  if (!trimmed) return '—';
  const withoutBrand = trimmed.replace(/^sonos[\s\-_]*/i, '').trim();
  if (!withoutBrand || /^sonos$/i.test(withoutBrand)) return '—';
  return withoutBrand;
}

function modelFontSize(model: string): number {
  if (model.length > 16) return 5;
  if (model.length > 12) return 5.5;
  if (model.length > 9) return 6.5;
  if (model.length > 6) return 7.5;
  return 8.5;
}

const SonosModelBadge: React.FC<SonosModelBadgeProps> = ({ modelo, size = BADGE_SIZE }) => {
  const model = useMemo(() => displayModel(modelo), [modelo]);
  const modelSize = modelFontSize(model);

  return (
    <Box
      sx={{
        width: size,
        height: size,
        minWidth: size,
        minHeight: size,
        maxWidth: size,
        maxHeight: size,
        aspectRatio: '1 / 1',
        borderRadius: '50%',
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        alignSelf: 'center',
        boxSizing: 'border-box',
        px: 0.4,
        overflow: 'hidden',
        userSelect: 'none',
      }}
    >
      <Box
        component="span"
        sx={{
          color: '#111',
          fontSize: 9,
          fontWeight: 800,
          letterSpacing: 0.15,
          lineHeight: 1,
          display: 'block',
        }}
      >
        Sonos
      </Box>
      <Box
        component="span"
        sx={{
          color: '#111',
          fontSize: modelSize,
          fontWeight: 600,
          lineHeight: 1.05,
          mt: 0.15,
          maxWidth: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          display: 'block',
          textAlign: 'center',
        }}
      >
        {model}
      </Box>
    </Box>
  );
};

export { BADGE_SIZE as SONOS_MODEL_BADGE_SIZE };
export default SonosModelBadge;
